<template>
  <v-menu>
    <template v-slot:activator="{on}">
      <v-text-field
          ref="textField"
          v-model="textValue"
          readonly
          v-on="on"
          :label="labelText"
          :outlined="!simple"
          :disabled="disabled"
          :rules="textFieldRules"
          @keypress.enter="onSubmit"
          maxlength=8
          :hide-details="simple"
          :append-icon="icon"
          :placeholder="placeholder"
          @click:append="onSubmit"
      ></v-text-field>
    </template>
     <div class="text-center" style="background: white">
      <v-date-picker
            v-model="date"
            :type="type"
            no-title
            scrollable
            reactive
            :locale="locale"
      />
      <div class="py-4">
        <v-btn small rounded depressed outlined color="primary" @click="currentJob">現在も働いている</v-btn>
      </div>
    </div>
  </v-menu>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "molecule",
    name: "EndDateField",
    components: {},
    props: {
      "value": String,
      "name": String,
      "type": String,
      "disabled": Boolean,
      "simple": Boolean,
      "required": Boolean,
      "min": Number,
      "max": Number,
      "rules": Array,
      "submit": Function,
      "icon": String,
      "placeholder": String,
    },
    computed: {
      date: {
        get () {
          if (this.value=="現在") {
            return null;
          }
          return this.value;
        },
        set (value) {
          this.$emit("input", value === "" ? null : value)
          this.$emit("toggleCurrentJob", false)
        },
      },
      textValue: {
        get () {
          return this.value;
        },
        set (value) {
          this.$emit("input", value === "" ? null : value)
        }
      },
      textFieldRules () {
        // 要修正
        return [
          value => {
            if (this.required)
              return !!value || this.error("required", [this.name]);
            return true;
          }
        ].concat(this.rules || [])
      },
      labelText () {
        return this.name
      },
      locale () {
        return this.$i18n.locale;
      }
    },
    methods: {
      currentJob () {
        this.$emit("input", "現在")
        this.$emit("toggleCurrentJob", true)
      },
      onSubmit () {
        if (this.submit) {
          this.submit();
        }
        this.$emit("enter", this.value);
      }
    }
  }
</script>

<style scoped>
</style>
